export const Checkbox = {
  variants: {
    primary: {
      control: {
        bg: 'brand.white',
        borderColor: 'var(--chakra-input-border)',
        _hover: {
          bg: 'var(--chakra-input-border)',
          borderColor: 'var(--chakra-input-border)',
        },
        _checked: {
          bg: 'brand.accent',
          borderColor: 'brand.accent',
          _hover: {
            bg: 'brand.accent',
            borderColor: 'brand.accent',
          },
        },

        _focusVisible: {
          boxShadow: 'none',
        },
        _focus: {
          boxShadow: 'none',
        },
      },
    },
    secondary: {
      control: {
        bg: 'brand.white',
        borderColor: 'var(--chakra-input-border)',
        _hover: {
          bg: 'var(--chakra-input-border)',
          borderColor: 'var(--chakra-input-border)',
        },
        _checked: {
          bg: 'brand.secondary',
          borderColor: 'brand.secondary',
          _hover: {
            bg: 'brand.secondary',
            borderColor: 'brand.secondary',
          },
        },

        _focusVisible: {
          boxShadow: 'none',
        },
        _focus: {
          boxShadow: 'none',
          border: '2px solid',
          borderColor: 'black',
        },
      },
    },
  },
  // The default variant values
  defaultProps: {
    variant: 'primary',
  },
}
